import {useEffect, useState} from "react";
import {useSnackbar} from "notistack";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ConfirmDialog from "../../ConfirmDialog";
import {useDeleteLeadSupervisorMutation} from "../../../services/authService";
import messages from "../../../utils/messages";
import styles from "../showName/DeleteShowName.module.scss";

const DeleteLeadSupervisor = ({ supervisor, setSupervisor, onDelete }) => {
    const [deleteLeadSupervisor, { isSuccess, error, reset }] = useDeleteLeadSupervisorMutation();
    const { enqueueSnackbar } = useSnackbar();

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleDelete = () => {
        deleteLeadSupervisor(supervisor.id);
    }

    const handleMessages = () => {
        if(isSuccess){
            enqueueSnackbar(`${messages.success.deleteLeadSupervisor}`, { variant: 'success' });
            reset();
            onDelete();
            setSupervisor(null);
        }
        if(error){
            enqueueSnackbar(`${messages.error.prefix} ${error?.data[0]?.errorMessage}`, { variant: 'error' });
        }
    }

    useEffect(() => {
        if(isSuccess || error){
            handleMessages();
        }
        // eslint-disable-next-line
    }, [isSuccess, error]);

    return (
        <>
            <DeleteOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon} m-1`}
            />
            <ConfirmDialog
                title="Delete lead supervisor"
                open={open}
                setOpen={setOpen}
                onConfirm={handleDelete}
            >
                {messages.confirm.deleteLeadSupervisor}
            </ConfirmDialog>
        </>
    )
}

export default DeleteLeadSupervisor;
